import { createEnumParam, useQueryParam, withDefault } from 'use-query-params';

export type TabValues = 'values' | 'details';

const TabParam = withDefault(createEnumParam<TabValues>(['values', 'details']), 'values');

const useTabParam = () => {
  return useQueryParam('tab', TabParam);
};

export default useTabParam;
